
export const getSlug = (imagedata: any) => {

let descTag =
imagedata.tags.filter(
  (tag: string) =>
    tag !== "cake" &&
    tag !== "cupcakes" &&
    tag !== "wedding" &&
    tag !== "fave"
)[0] || "";

// replace all url characters that are not alphanumeric or a dash in descTag
descTag = descTag.replace("#fave", "");
descTag = descTag.replace(/[^a-zA-Z0-9-_]/g, "-");

const slug =
"/" +
imagedata.created_at.replace("T", "").replace("Z", "").replace(/:/g, "").replace(/-/g, "") +
"/" +
descTag;

return slug;
}